import styled from 'styled-components'
import { Tipografia } from '../Tipografia'

export const graficoDonutStyles = {
  Tipografia: styled(Tipografia)`
    max-width: 300px;
  `
}
